// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/modelsAll.scss'

// Models Search Form
async function getHmsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "houseModelsSearchForm" */ './js/components/houseModelsSearchForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $('#sub-nav').height()
      $('html').animate({ scrollTop: $('#step-pagination').offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
    })
  })
}

// Model Display Form
async function getMDForm ($f) {
  $f.load()
  import(/* webpackChunkName: "modelDisplayForm" */ './js/components/modelDisplayForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des alertes BS
  const $c1 = $('.alert')
  if ($c1.length) {
    $c1.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de recherche des modèles
  const $c2 = $('form[name="qhmsForm"]')
  if ($c2.length) {
    $c2.waypoint(function () {
      getHmsForm($c2)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $c3 = $('.pajinate')
  if ($c3.length) {
    $c3.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la localisation
  const $c4 = $('form[name="mdForm"]')
  if ($c4.length) {
    $c4.waypoint(function () {
      getMDForm($c4)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion model items
  const $modelitem = $('.model-item')
  if ($modelitem.length) {
    $modelitem.waypoint(function () {
      import(/* webpackChunkName: "modelItem" */ './scss/components/modelItem.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c5 = $('form[name="cForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getCForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  const $go = $('#go')
  if ($go.length) {
    const h = $('#header').height()
    const p = $('#sub-nav').height()
    $('html').animate({ scrollTop: $go.offset().top - h - p - 40 }, { duration: 300, easing: 'linear' }, function () {
      $('html').animate({ scrollTop: $go.offset().top - h - p - 40 }, { duration: 300, easing: 'linear' })
    })
  }

  // ancre
  $.each($('.scroll'), function (i, elem) {
    $(elem).off().on('click', function (e) {
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($(t).length > 0) {
        const h = $('#header').height()
        const p = $('#sub-nav').height()
        $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' }, function () {
          $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
        })
      }
    })
  })

  // gestion des filtres depuis la navbar
  const $mn = $('#sub-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })
})
